import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from "react-grid-system";
import { FEATURE_CARDS } from "../../constants/featureCards";

const FeatureCardItem = ({ icon, title, description }) => {
    return (
        <div className="feature-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="feature-card-icon">
                <i className={icon}></i>
            </div>
            <div className="feature-card-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <h4 className="feature-card-title">{title}</h4>
                <p className="feature-card-description">{description}</p>
            </div>
        </div>
    );
};

FeatureCardItem.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

const FeatureCard = ({ features = FEATURE_CARDS, containerStyle, colStyle }) => {
    return (
        <Row className="feature-card-container" style={containerStyle}>
            {features.map((feature, index) => (
                <Col lg={3} md={6} sm={12} key={index} style={{ marginBottom: '20px', paddingLeft: '10px', paddingRight: '10px', ...colStyle }}>
                    <FeatureCardItem
                        icon={feature.icon}
                        title={feature.title}
                        description={feature.description}
                    />
                </Col>
            ))}
        </Row>
    );
};

FeatureCard.propTypes = {
    features: PropTypes.array,
    containerStyle: PropTypes.object,
    colStyle: PropTypes.object
};

export default FeatureCard;
